export function formatKg(n) {
  const v = Number(n || 0);
  return v.toFixed(2).replace(".", ",") + " kg";
}

export function formatMedida(valor, unidade) {
  const u = unidade === "m" ? "m" : "kg";
  return Number(valor || 0).toFixed(2).replace(".", ",") + " " + u;
}

export function unidadeLabel(unidade) {
  return unidade === "m" ? "m" : "kg";
}

export function formatNum(n) {
  return Number(n || 0).toFixed(2).replace(".", ",");
}

export function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${formatDate(iso)} ${hh}:${min}`;
}

export const STATUS_META = {
  ok: { label: "OK", color: "#16A34A", bg: "#F0FDF4", border: "#16A34A" },
  atencao: { label: "Atenção", color: "#CA8A04", bg: "#FEFCE8", border: "#EAB308" },
  baixo: { label: "Baixo", color: "#DC2626", bg: "#FEF2F2", border: "#DC2626" },
  zerado: { label: "Zerado", color: "#475569", bg: "#F1F5F9", border: "#475569" },
};
